<div class="dropdown rounded-3" ngbDropdown clickOutside id="projectbtn">
    <button class="btn h-40px w-32px btn-outline-danger rounded-0 exportBtn text-white  dropdown-toggle pt-0-6"
        pTooltip="{{'ExporttoPDFExcel'|localize}}" tooltipPosition="bottom"
        [ngClass]="[classForExportDropdownButton ?  classForExportDropdownButton : '']" ngbDropdownToggle
        [disabled]="disabled">
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 26 25">
            <g id="Group_113562" data-name="Group 113562" transform="translate(-1475.931 -10982.5)">
                <path id="Path_100953" data-name="Path 100953"
                    d="M1486.866,11004.518h-10.435V10983h11.586l4.966,4.966v4.426" fill="none" stroke="#de285a"
                    stroke-linejoin="round" stroke-width="1" />
                <path id="Path_100954" data-name="Path 100954" d="M1504.431,10983v4.966h4.966"
                    transform="translate(-16.414)" fill="none" stroke="#de285a" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="1" />
                <g id="Group_113563" data-name="Group 113563" transform="translate(1488.845 10995.414)">
                    <circle id="Ellipse_7771" data-name="Ellipse 7771" cx="5.793" cy="5.793" r="5.793"
                        transform="translate(0 0)" fill="none" stroke="#de285a" stroke-miterlimit="10"
                        stroke-width="1" />
                    <g id="Group_113562-2" data-name="Group 113562" transform="translate(2.998 3.31)">
                        <line id="Line_87994" data-name="Line 87994" x1="5.692" transform="translate(0 2.483)"
                            fill="none" stroke="#de285a" stroke-linecap="round" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_100955" data-name="Path 100955" d="M1521.431,11021l2.483,2.482-2.483,2.07"
                            transform="translate(-1518.222 -11021)" fill="none" stroke="#de285a" stroke-linecap="round"
                            stroke-miterlimit="10" stroke-width="1" />
                    </g>
                </g>
            </g>
        </svg>
    </button>
    <ul ngbDropdownMenu class="dropdown-menu pt-0 pb-0 indexset dropdownAlignment" id="dropMenuExport">
        <li ngbDropdownItem>
            <div class=" mt-2 pb-0 pt-0 d-flex" (click)="exportGrid(1)">
                <div class="mr-2">
                    <img src="assets/common/images/exportDropdown/ExportalldatatoPDF.svg" class="w-20px h-20px">
                </div>
                <div class="ml-2">
                    <h6 class=" font-weight-normal intime-font-14 intime-open-sans text-dark-65 mb-0">
                        {{'ExportalldatatoPDF' | localize}}
                    </h6>
                </div>
            </div>
        </li>
        <li ngbDropdownItem [ngClass]="{'disabled-option': !ifGridHaveCheckBox}">
            <div class=" pb-0 pt-0 d-flex" [class.disabled-item]="!ifGridHaveCheckBox"
                (click)="ifGridHaveCheckBox ? exportGrid(2) : null">
                <div class="mr-2">
                    <img src="assets/common/images/exportDropdown/ExportselectedrowstoPDF.svg" class="w-20px h-20px">
                </div>
                <div class="ml-2">
                    <h6 class=" font-weight-normal intime-font-14 intime-open-sans text-dark-65 mb-0"
                        [class.text-muted]="!ifGridHaveCheckBox">
                        {{'ExportrowstoPDF' | localize}}
                    </h6>
                </div>
            </div>
        </li>
        <li ngbDropdownItem>
            <div class=" pb-0 pt-0 d-flex" (click)="exportGrid(3)">
                <div class="mr-2">
                    <img src="assets/common/images/exportDropdown/ExportalldatatoExcel.svg" class="w-20px h-20px">
                </div>
                <div class="ml-2">
                    <h6 class=" font-weight-normal intime-font-14 intime-open-sans text-dark-65 mb-0">
                        {{'ExportalldatatoExcel' | localize}}
                    </h6>
                </div>
            </div>
        </li>
        <li ngbDropdownItem [ngClass]="{'disabled-option': !ifGridHaveCheckBox}">
            <div class=" pb-0 pt-0 d-flex" [class.disabled-item]="!ifGridHaveCheckBox"
                (click)="ifGridHaveCheckBox ? exportGrid(4) : null">
                <div class="mr-2">
                    <img src="assets/common/images/exportDropdown/ExportselectedrowstoExcel.svg" class="w-20px h-20px">
                </div>
                <div class="ml-2">
                    <h6 class=" font-weight-normal intime-font-14 intime-open-sans text-dark-65 mb-0"
                        [class.text-muted]="!ifGridHaveCheckBox">
                        {{'ExportrowstoExcel' | localize}}
                    </h6>
                </div>
            </div>
        </li>
    </ul>
</div>